import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, get, set, remove } from "firebase/database";
import { v4 as uuid } from 'uuid'
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DB_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth()
const provider = new GoogleAuthProvider()
const database = getDatabase(app)

export function login() {
    signInWithPopup(auth, provider)
        .catch(console.error)
}

export function logout() {
    signOut(auth).catch(console.error)
}

export function onUserStateChange(callback) {
    onAuthStateChanged(auth, async (user) => {
        const updatedUser = user ? await adminUser(user) : null;
        callback(updatedUser)
    });
}

async function adminUser(user) {
    return get(ref(database, 'admins'))
        .then((snapshot) => {
            if (snapshot.exists()) {
                const admins = snapshot.val()
                console.log(admins);
                const isAdmin = admins.includes(user.uid)
                return { ...user, isAdmin }
            } else {
                console.log("No data available");
                return user;
            }
        }).catch((error) => {
            console.error(error);
        })
}

export async function addNewProduct(product, image) {
    const id = uuid()
    return set(ref(database, `products/${id}`), {
        ...product,
        id,
        price: parseInt(product.price),
        image,
        options: product.options.split(',')
    })
}
export async function getProducts() {
    return get(ref(database, 'products'))
        .then((snapshot) => {
            if (snapshot.exists()) {
                return Object.values(snapshot.val())
            }
            return []
        })
}

export async function addOrUpdateToCart(userId, product) {

    return set(ref(database, `cart/${userId}/${product.id}`), product)
}

export async function getCart(userId) {
    return get(ref(database, `cart/${userId}`))
        .then((snapshot) => {
            const items = snapshot.val() || {}
            return Object.values(items)
        })
}

export async function deleteItemFromCart(userId, productId) {
    return remove(ref(database, `cart/${userId}/${productId}`))
}